import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['target', 'template', 'removeModal']

  connect() {
    if (this.hasRemoveModalTarget) {
      this.removeModalInstance = new window.bootstrap.Modal(this.removeModalTarget)
    }
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.targetTarget.insertAdjacentHTML('beforebegin', content)
  }

  openConfirmRemove(event) {
    event.preventDefault()
    const selector = event.target.dataset.wrapperSelector
    this.wrapperToRemove = event.target.closest(selector)
    this.removeModalInstance.show()
  }

  remove(event) {
    event.preventDefault()
    let wrapper
    if (this.wrapperToRemove) {
      wrapper = this.wrapperToRemove
      this.wrapperToRemove = null
      if (this.removeModalInstance) this.removeModalInstance.hide()
    } else {
      const selector = event.target.dataset.wrapperSelector
      wrapper = event.target.closest(selector)
    }
    if (!wrapper) return
    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove()
    } else {
      wrapper.style.display = 'none'
      wrapper.querySelector("input[name*='_destroy']").value = '1'
    }

  }
}
